module.exports = __webpack_public_path__ + "static/media/SumoLogo.ec8d1f22.png";